import { internalFetch } from '../utils/fetchHelper';
export interface TenantCategory {
  code: string;
  label: string;
  isActive: boolean;
  revision: number;
}
export interface TenantFormAccess {
  formDefinitionId: number;
  requiredCategoryCodes: string[];
  isAllowed: boolean | null;
}
export interface TenantOrderPolicy {
  enabled: boolean;
  categoryCodes: string[];
  forms: TenantFormAccess[];
}
export interface TenantAvailableForm {
  id: number;
  code: string;
  label: string;
  entityType: string;
  publishedMetadataId?: number | null;
}
export interface TenantOrderAccess {
  revision: number;
  policy: TenantOrderPolicy | null;
  forms: TenantAvailableForm[];
  categories: TenantCategory[];
  history: {
    revision: number;
    reason: string;
    createdAt: string;
    createdBy: number;
    policy: TenantOrderPolicy;
  }[];
}
export interface SaveTenantOrderAccess {
  operationId: string;
  expectedRevision: number;
  reason: string;
  policy: TenantOrderPolicy;
}
const api = import.meta.env.VITE_BACKEND_API_URL as string;
export const loadTenantCategories = (
  controller: AbortController
): Promise<TenantCategory[]> =>
  internalFetch(`${api}/p/clientCategories`, 'GET', controller);
export const loadTenantOrderAccess = (
  controller: AbortController
): Promise<TenantOrderAccess> =>
  internalFetch(`${api}/p/clientOrderAccess`, 'GET', controller);
export const saveTenantOrderAccess = (
  controller: AbortController,
  request: SaveTenantOrderAccess
): Promise<TenantOrderAccess> =>
  internalFetch(
    `${api}/p/clientOrderAccess`,
    'PUT',
    controller,
    JSON.stringify(request)
  );
export const saveTenantCategory = (
  controller: AbortController,
  code: string,
  request: { label: string; isActive: boolean; expectedRevision: number }
): Promise<TenantCategory[]> =>
  internalFetch(
    `${api}/p/clientCategory/${encodeURIComponent(code)}`,
    'PUT',
    controller,
    JSON.stringify(request)
  );
